module.exports = __webpack_public_path__ + "static/media/21ECLAC9.db2f1cf8.jpg";